<script>

</script>
{#snippet purpleHeader(text)}
    <h2 class="text-3xl font-semibold" style="color: #4D2DB7;">{text}</h2>
{/snippet}

<div id="page3" class="space-y-2 text-center" style="color: #4D2DB7;">
            {@render purpleHeader("Oops! Come back next week!")}
            
            <div class="space-y-4x">
                <p>For this study, you can participate once per calendar</p>
                <p>week (Monday-Sunday). You have already</p>
                <p>participated once this week. You may participate</p>
                <p>again <span>any time next week, starting from Monday</span></p>
                <p><span>12:00 AM.</span></p>
            </div>
            
            <div class="space-y-4x">
                <p>Thank you for participating in the VITAL study!</p>
            </div>
            
        </div>